/* Les pop-ups des fixations — voir snippets/simply-fixation-popups.liquid
 *
 * Tout bouton [data-simply-popup="<handle>"] de la page ouvre le <dialog>
 * #simply-fixation-<handle> : lignes du selecteur de montage comme lignes
 * « Our pick ». Fermeture par le bouton, par Echap (natif) ou par un clic hors
 * du cadre ; le focus revient au bouton d'origine.
 *
 * Le bouton « Details » est dans le <label> d'une ligne de fixation : sans
 * preventDefault, le clic cocherait la fixation au passage.
 */
(() => {
  if (window.simplyPopups) return;
  window.simplyPopups = true;

  document.addEventListener('click', (e) => {
    const ouvre = e.target.closest('[data-simply-popup]');
    if (ouvre) {
      e.preventDefault();
      const dialogue = document.getElementById(`simply-fixation-${ouvre.dataset.simplyPopup}`);
      if (!dialogue || dialogue.open) return;
      dialogue.origine = ouvre;
      dialogue.showModal();
      return;
    }
    const ferme = e.target.closest('[data-simply-fermer]');
    if (ferme) {
      ferme.closest('dialog').close();
      return;
    }
    // Le cadre remplit le <dialog> : un clic dont la cible est le <dialog>
    // lui-meme est un clic sur le fond.
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('simply-popup')) {
      e.target.close();
    }
  });

  document.addEventListener('close', (e) => {
    const dialogue = e.target;
    if (dialogue.classList && dialogue.classList.contains('simply-popup') && dialogue.origine) {
      dialogue.origine.focus();
    }
  }, true);
})();
